import React from 'react';
import './IconOwnerLike.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/pro-solid-svg-icons';
import { apiCropImage } from '../../../../config';

const classGenders = {
  1: 'gender-man',
  2: 'gender-woman',
  3: 'gender-couple',
  4: 'gender-couple-lesbian',
  5: 'gender-couple-gay',
  6: 'gender-trav',
  guest: 'guest',
  group: 'group'
};

const IconOwnerLike = ({avatar, gender}) => {
  let defaultGenderAvatar = classGenders[gender || 1] || "gender-man";
  let src = `${process.env.PUBLIC_URL}/images/avatars/${defaultGenderAvatar}.jpg`;
  if (avatar) {
      src = apiCropImage({url: avatar, width: 20, height: 20});
  }
  return (
    <div className="icon-owner-like-wrapper">
        <FontAwesomeIcon className="icon-owner-like" icon={faHeart}/>
      <img src={src} alt="" />
    </div>
  );
};

export default IconOwnerLike;
